(function ($) {

    let $container;
    let timerBlur;

    /**
     * Инициализирует модуль
     */
    document.addEventListener('DOMContentLoaded', () => {
        $container = $('.filter');

        onFilterDropdownClick();
        onFilterDropdownLossFocus();
        onFilterDropdownChange();
        onFilterDropdownItemClick();
        onFilterDropdownClearClick();
        onKeyDown();
    });

    /**
     * Обработчик события: получен фокус
     *
     */
    function onFilterDropdownClick() {
        $container.off('click', '.filter-dropdown__button');
        $container.on('click', '.filter-dropdown__button', (e) => {
            let $filterDropdown = $(e.currentTarget).parents('.filter-dropdown');

            if (!e.currentTarget.classList.contains('has-focus')) {
                e.currentTarget.classList.add('has-focus');
                e.currentTarget.parentElement.querySelector('.filter-dropdown__select').classList.add('show');
            } else {
                hideFilterDropdown($filterDropdown[0]);
            }

        });
    }

    /**
     * Обработчик события: потеря фокуса
     *
     */
    function onFilterDropdownLossFocus() {
        $container.off('blur', '.filter-dropdown__button');
        $container.on('blur', '.filter-dropdown__button', (e) => {
            let $filterDropdown = $(e.currentTarget).parents('.filter-dropdown');
            timerBlur = setTimeout(() => hideFilterDropdown($filterDropdown[0]), 300);
        });
    }

    /**
     * Обработчик события: клик по элементу в фильтре Dropdown
     *
     */
    function onFilterDropdownItemClick() {
        $container.off('click', '.filter-dropdown__item');
        $container.on('click', '.filter-dropdown__item', (e) => {
            let $filterDropdown = $(e.currentTarget).parents('.filter-dropdown');

            if (e.currentTarget.classList.contains('filter-dropdown__item--more')) {
                clearTimeout(timerBlur);

                showMore($filterDropdown[0], !e.currentTarget.classList.contains('show'));
                $filterDropdown.find('.filter-dropdown__button').focus();
                return;
            }

            $filterDropdown.find('.filter-dropdown__selected-text').text(e.currentTarget.textContent);
            $filterDropdown.find('.filter-dropdown__caret').addClass('hide');
            $filterDropdown.find('.filter-dropdown__clear').removeClass('hide');

            hideFilterDropdown($filterDropdown[0])
        });
    }

    /**
     * Обработчик события: клик по элементу в фильтре Dropdown
     *
     */
    function onFilterDropdownChange() {
        $container.off('change', '.filter-dropdown input[type=radio]');
        $container.on('change', '.filter-dropdown input[type=radio]', () => {
            $.publish('filter-type:get-current').promise().done((filterType, searchedData) => {
                if (document.querySelector('.multilevel-list.show[data-filter-type="' + filterType + '"]')) {
                    return;
                }

                $.publish('filter-changed');
            });
        });
    }

    /**
     * Обработчик события: клик по кнопке Очистить фильтр
     *
     */
    function onFilterDropdownClearClick() {
        $container.off('click', '.filter-dropdown__clear');
        $container.on('click', '.filter-dropdown__clear', (e) => {
            let $filterDropdown = $(e.currentTarget).parents('.filter-dropdown');

            $filterDropdown.find('.filter-dropdown__selected-text').text(e.currentTarget.textContent);
            $filterDropdown.find('.filter-dropdown__caret').removeClass('hide');
            $filterDropdown.find('.filter-dropdown__clear').addClass('hide');

            hideFilterDropdown($filterDropdown[0]);

            $.publish('filter-changed');

            e.stopPropagation();
        });
    }

    /**
     * Скрывает указанный фильтр
     *
     */
    function hideFilterDropdown(filterDropdown) {

        filterDropdown.querySelector('.filter-dropdown__button').classList.remove('has-focus');
        filterDropdown.querySelector('.filter-dropdown__select').classList.remove('show');

        showMore(filterDropdown, false);
    }

    /**
     * Скрывает указанный фильтр
     *
     */
    function showMore(filterDropdown, show) {

        if (show) {
            filterDropdown.querySelector('.filter-dropdown__item--more').classList.add('show');
        } else {
            filterDropdown.querySelector('.filter-dropdown__item--more').classList.remove('show');
        }

    }

    /**
     * Обработчик события: нажатие клавиши
     *
     */
    function onKeyDown() {
        window.addEventListener('keydown', function (e) {
            if (e.keyCode === 27) {
                //hideFilterDropdown(filterDropdown);
            }
        });
    }
})(window.jQuery);